import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";
import Badge from "../ui/Badge";
import Card from "../ui/Card";
import SectionTitle from "../ui/SectionTitle";

export default function Experience() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14" id="experience">
      <SectionTitle
        kicker="Timeline"
        title="Experience"
        subtitle="Evidence of ownership across GenAI systems, automation, ETL pipelines, and operational impact."
      />

      <div className="space-y-5">
        {DATA.experience.map((e) => (
          <Card key={e.role + e.org} className="relative">
            <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
              <div>
                <div className="text-lg font-semibold text-white">
                  {e.role} <span className="text-white/60">—</span> {e.org}
                </div>
                <div className="mt-1 text-sm text-white/70">
                  {e.time} • {e.place}
                </div>
              </div>

              <div className="flex flex-wrap gap-2">
                {e.stack.slice(0, 5).map((x) => (
                  <Badge key={x}>{x}</Badge>
                ))}
              </div>
            </div>

            <ul className="mt-4 space-y-2 text-sm text-white/70">
              {e.bullets.map((b) => (
                <li key={b} className="flex gap-2">
                  <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-fuchsia-400/70" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-4 text-xs text-white/60">
              Tech: {e.stack.join(" • ")}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
